"use client";
import React from "react";

export const TopicTags = ({ tags, selectedTag, onSelectTag }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      <button
        className={`px-4 py-2 text-sm font-medium rounded-full transition-colors ${
          selectedTag === "all"
            ? "bg-rose-700 text-white"
            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
        }`}
        onClick={() => onSelectTag("all")}
      >
        All Topics
      </button>
      {tags && tags.map((tag) => (
        <button
          key={tag.id}
          className={`px-4 py-2 text-sm font-medium rounded-full transition-colors ${
            selectedTag === tag.id
              ? "bg-rose-700 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
          onClick={() => onSelectTag(tag.id)}
        >
          {tag.name}
        </button>
      ))}
    </div>
  );
};
